<app-loading *ngIf="!isLoaded"></app-loading>

<div *ngIf="isLoaded">

    <div style='font-size:1.2em;' class="groupTitle">Sessions</div>

    <div class='row details-body'>
        <div class='col-sm-12'>
            <div *ngIf='errorMsg' class='text-center alert-text'>{{errorMsg}}</div>

            <div *ngIf="!loadingError">

                <div class='index'>
                    <div *ngFor="let session of sessions" class='row'>
                        <app-landing-page-course-session [course]="course" [session]="session"></app-landing-page-course-session>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>